import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=426f2060&scoped=true"
import script from "./docs.vue?vue&type=script&lang=js"
export * from "./docs.vue?vue&type=script&lang=js"
import style0 from "./docs.vue?vue&type=style&index=0&id=426f2060&prod&scoped=true&lang=stylus"
import style1 from "./docs.vue?vue&type=style&index=1&id=426f2060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426f2060",
  null
  
)

export default component.exports